import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import Users from './components/Users';
import UserDetail from './components/UserDetail';
import Layout from './components/Layout';

const API_BASE_URL = 'https://jaejtnxq15.execute-api.us-east-1.amazonaws.com/prod/v1';

function App() {
  const [token, setToken] = useState(localStorage.getItem('adminToken'));
  const [user, setUser] = useState(null);

  useEffect(() => {
    if (token) {
      console.log('Validating token:', token);
      // Decode our custom token format
      try {
        if (token.startsWith('admin_')) {
          const tokenData = token.substring(6); // Remove 'admin_' prefix
          const payload = JSON.parse(atob(tokenData));
          console.log('Token payload:', payload);

          // Check if token is expired
          if (payload.exp && payload.exp < Date.now() / 1000) {
            console.log('Token expired');
            setToken(null);
            localStorage.removeItem('adminToken');
            return;
          }

          console.log('Setting user from token:', payload);
          setUser({ username: payload.username, role: payload.role });
        } else {
          console.log('Invalid token format');
          // Invalid token format
          setToken(null);
          localStorage.removeItem('adminToken');
        }
      } catch (e) {
        console.log('Token parsing error:', e);
        // Invalid token
        setToken(null);
        localStorage.removeItem('adminToken');
      }
    }
  }, [token]);

  const handleLogin = (newToken, userData) => {
    console.log('Login successful, setting token:', newToken);
    setToken(newToken);
    setUser(userData);
    localStorage.setItem('adminToken', newToken);
  };

  const handleLogout = () => {
    setToken(null);
    setUser(null);
    localStorage.removeItem('adminToken');
  };

  if (!token) {
    return <Login onLogin={handleLogin} apiBaseUrl={API_BASE_URL} />;
  }

  return (
    <Router>
      <Layout user={user} onLogout={handleLogout}>
        <Routes>
          <Route path="/" element={<Navigate to="/dashboard" />} />
          <Route
            path="/dashboard"
            element={<Dashboard token={token} apiBaseUrl={API_BASE_URL} />}
          />
          <Route
            path="/users"
            element={<Users token={token} apiBaseUrl={API_BASE_URL} />}
          />
          <Route
            path="/users/:email"
            element={<UserDetail token={token} apiBaseUrl={API_BASE_URL} />}
          />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;